import { combineReducers } from '@reduxjs/toolkit';
import partner from "./partnerSlice";

const partnerReducer = combineReducers({
    partner
});

export default partnerReducer;